import { F, T } from '@/helpers'
import { createEvent, createStore, sample, split } from 'effector'
import { epgRegionsModel } from '~/entities/epg/regions'
import { preferencesFeatureModel } from '~/features/preferences'
import { selectEpgRegionModel } from './select'

// Popup controls
export const openRegionsPopup = createEvent()
export const closeRegionsPopup = createEvent()
export const $isRegionsPopupOpened = createStore(false)
  .on(openRegionsPopup, T)
  .on(closeRegionsPopup, F)

// Events for region selection logic
export const checkPreferredRegion = createEvent()
export const checkOpenPopup = createEvent()

// Set region from preferences if it is available in the list of available regions
sample({
  clock: checkPreferredRegion,
  source: {
    prefferedRegion: preferencesFeatureModel.$preference,
    regions: epgRegionsModel.$regionsAlphabeticallySorted,
  },
  filter: ({ prefferedRegion, regions }) => {
    const isPreferredRegionAvailable = regions?.find(
      (region) => region.id === prefferedRegion?.id
    )
    return Boolean(isPreferredRegionAvailable)
  },
  fn: ({ prefferedRegion }) => prefferedRegion,
  target: selectEpgRegionModel.setRegion,
})

// If preferred region is not available in the list of available regions, should check open popup logic
sample({
  clock: checkPreferredRegion,
  source: {
    prefferedRegion: preferencesFeatureModel.$preference,
    regions: epgRegionsModel.$regionsAlphabeticallySorted,
  },
  filter: ({ prefferedRegion, regions }) => {
    const isPreferredRegionAvailable = regions?.find(
      (region) => region.id === prefferedRegion?.id
    )
    return !isPreferredRegionAvailable
  },
  target: checkOpenPopup,
})

const setOnlyOneAvailableRegion = createEvent()
// If there are multiple regions available, open the region selection popup.
// If there is exactly one region available, automatically set it as the active region.
split({
  clock: checkOpenPopup,
  source: epgRegionsModel.$totalRegions,
  match: {
    openRegionsPopup: (totalRegions) => totalRegions > 1,
    setOnlyOneAvailableRegion: (totalRegions) => totalRegions === 1,
  },
  cases: {
    openRegionsPopup,
    setOnlyOneAvailableRegion,
  },
})

// Set region from storage if there is only one region without showing popup
sample({
  clock: setOnlyOneAvailableRegion,
  source: epgRegionsModel.$regionsAlphabeticallySorted,
  fn: (regions) => {
    return regions?.[0]
  },
  target: selectEpgRegionModel.setRegion,
})
